import React from "react";
import "../theme/Administracion.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionBanners } from "../components/TableAdministracionBanners";
import { authProvider } from "../context/authProvider";
import { useNavigate } from "react-router-dom";
import { useColoresEmpresa } from "../hooks/useColoresEmpresa";

export const AdminPageBanner = () => {
  const navigate = useNavigate();
  useColoresEmpresa();

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <button className="button-goback-style" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                  </button>
                  <div> Administración de Banners </div>
                </div>
              </div>

              <TableAdministracionBanners />
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
